import AccountRemoveError from './AccountRemoveError';

export default AccountRemoveError;
